import {useEffect} from "react";

export const DoSomethingWrapper = ({ children }) => {
  useEffect(() => {
      window.location.href = process.env.REACT_APP_API_URL + "/t8/v1/authenticate";
  }, []);
  return children;
};